// import { request } from '@/myops/core'
import request from '@/lib/utils/request'

export function getQueryAnswerPageList(params) {
  return request({
    url: '/cssa/api/chat/getQueryAnswerPageList',
    method: 'post',
    data: params,
  })
}

export function evaluationById(params) {
  return request({
    url: '/cssa/api/chat/evaluationById',
    method: 'post',
    data: params,
  })
}

export function getAnswerLikePageList(params) {
  return request({
    url: '/cssa/api/chat/getAnswerLikePageList',
    method: 'post',
    data: params,
  })
}

export function uploadFile(params) {
  return request({
    url: '/cssa/api/chat/uploadFile',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: params,
  })
}

export function getChatBotFilePageList(params) {
  return request({
    url: '/cssa/api/chat/getChatBotFilePageList',
    method: 'post',
    data: params,
  })
}

export function getFile(params) {
  return request({
    url: '/cssa/api/chat/getFile',
    method: 'get',
    responseType: 'blob',
    params,
  })
}

export function getSensitiveWordPageList(params) {
  return request({
    url: '/cssa/api/chat/getSensitiveWordPageList',
    method: 'post',
    data: params,
  })
}

export function addSensitiveWord(params) {
  return request({
    url: '/cssa/api/chat/addSensitiveWord',
    method: 'post',
    data: params,
  })
}

export function updateSensitiveWord(params) {
  return request({
    url: '/cssa/api/chat/updateSensitiveWord',
    method: 'post',
    data: params,
  })
}

export function deleteSensitiveWord(params) {
  return request({
    url: '/cssa/api/chat/deleteSensitiveWord',
    method: 'post',
    data: params,
  })
}

export function sensitiveAnalysis(params) {
  return request({
    url: '/cssa/api/chat/sensitiveAnalysis',
    method: 'get',
    params,
  })
}

export function getChatBotKvTemplatePageList(params) {
  return request({
    url: '/cssa/api/chat/getChatBotKvTemplatePageList',
    method: 'get',
    params,
  })
}

export function addChatBotKvTemplate(params) {
  return request({
    url: '/cssa/api/chat/addChatBotKvTemplate',
    method: 'post',
    data: params,
  })
}

export function deleteKvTemplate(params) {
  return request({
    url: '/cssa/api/chat/deleteKvTemplate',
    method: 'post',
    data: params,
  })
}

export function updateKvTemplate(params) {
  return request({
    url: '/cssa/api/chat/updateKvTemplate',
    method: 'post',
    data: params,
  })
}

export function addCategory(data) {
  return request({
    url: '/cssa/api/chat/addCategory',
    method: 'post',
    data,
  })
}

export function updateCategory(data) {
  return request({
    url: '/cssa/api/chat/updateCategory',
    method: 'post',
    data,
  })
}

export function getCategoryPageList(data) {
  return request({
    url: '/cssa/api/chat/getCategoryPageList',
    method: 'post',
    data,
  })
}

export function deleteCategoryById(params) {
  return request({
    url: '/cssa/api/chat/deleteCategoryById',
    method: 'get',
    params,
  })
}

export function saveSystemShutdownSetting(data) {
  return request({
    url: '/cssa/api/ChatbotSystemShutdownSettingController/save',
    method: 'post',
    data,
  })
}

export function getSystemShutdownSettingPageList(params) {
  return request({
    url: '/cssa/api/ChatbotSystemShutdownSettingController/getPageList',
    method: 'get',
    params,
  })
}

export function getLookUp(data) {
  return request({
    url: '/cssa/api/lookup/getLookUp',
    method: 'post',
    data,
  })
}

export function updateSystemShutdownSetting(data) {
  return request({
    url: '/cssa/api/lookup/updateSystemShutdownSetting',
    method: 'post',
    data,
  })
}

export function switchSystemShutdownSetting(data) {
  return request({
    url: '/cssa/api/ChatbotSystemShutdownSettingController/switchSystemShutdownSetting',
    method: 'post',
    data,
  })
}

export function updatePlaceUsingHeader(data) {
  return request({
    url: '/cssa/api/updateApiHeader/updatePlaceUsingHeader',
    method: 'post',
    data
  })
}

export function updateRoomChangeHeader(data) {
  return request({
    url: '/cssa/api/updateApiHeader/updateRoomChangeHeader',
    method: 'post',
    data
  })
}

export function downloadQueryContentList(data) {
  return request({
    url: '/cssa/api/chat/downloadQueryContentList',
    method: 'post',
    data,
    responseType: 'arraybuffer',
  })
}

